import React from 'react'

import Routes from './routes'

const Branding = () => {
  return <Routes />
}

export default Branding
